import { render } from "./SliderNotificationDetails.vue?vue&type=template&id=3dabd3ef&scoped=true"
import script from "./SliderNotificationDetails.vue?vue&type=script&lang=js"
export * from "./SliderNotificationDetails.vue?vue&type=script&lang=js"

import "./SliderNotificationDetails.vue?vue&type=style&index=0&id=3dabd3ef&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src338202144/src/web-app-vue-3/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3dabd3ef"]])

export default __exports__